import { Mui } from "@leap4/frontend";
import { seriesColors } from "../../theme/colors";

const { Box, Typography } = Mui;

/** "VIEWLENS" between two fading rules, sized to sit under the Adte logo. */
export const ViewLensWordmark = ({ size = "small" }: { size?: "small" | "large" }) => {
    const large = size === "large";
    const spacing = large ? "0.3em" : "0.22em";
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: large ? 1.5 : 1, width: "100%", maxWidth: large ? 300 : 170 }}>
            <Box aria-hidden="true" sx={{ flex: 1, height: "1px", background: `linear-gradient(90deg, transparent, ${seriesColors.impressions})` }} />
            <Typography
                noWrap
                sx={{
                    fontSize: large ? "1.125rem" : "0.8125rem",
                    fontWeight: 600,
                    letterSpacing: spacing,
                    mr: `-${spacing}`,
                    textTransform: "uppercase",
                    background: `linear-gradient(90deg, #A5B4FC, ${seriesColors.impressions})`,
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    color: "transparent",
                }}
            >
                ViewLens
            </Typography>
            <Box aria-hidden="true" sx={{ flex: 1, height: "1px", background: `linear-gradient(90deg, ${seriesColors.impressions}, transparent)` }} />
        </Box>
    );
};
